import { Checkbox, Col, Form, FormInstance, Row } from 'antd';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import moment from 'moment';
import { BillingExpenseRevenueFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';

interface Props {
  form: FormInstance<BillingExpenseRevenueFormValues>;
}

function InvoicingBillingXPaymentsXReceiptsForm({ form }: Props) {
  return (
    <Form layout="vertical" form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <FloatingFormItem
            name="startDate"
            label={'Data Inicial'}
            initialValue={moment().subtract(5, 'months')}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="endDate"
            label={'Data Final'}
            initialValue={moment()}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem label={'Empresas'} name="companiesIds">
            <CompaniesInfiniteSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <Form.Item
            name="displayOverdueExpenses"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox style={{ marginTop: '12px' }}>
              Exibir despesas atrasadas
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="displayOverdueReceipts"
            initialValue={false}
            valuePropName="checked"
          >
            <Checkbox style={{ marginTop: '12px' }}>
              Exibir receitas atrasadas
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default InvoicingBillingXPaymentsXReceiptsForm;
